import React from 'react';
import cx from 'classnames';
import { Divider } from '../../../Divider';
import { NameInitials } from '../../../NameInitials';
import { DataStoreProps } from '../../common/types';
import styles from '../style.module.css';
import { Description } from './Description';
import { ShopAddressAndHourMobile } from './ShopAddressAndHourMobile';
import { ShopContact } from './ShopContact';
import { ShopRatings } from './ShopRatings';
import { ShopTitle } from './ShopTitle';

export const CompleteMobile = ({
  dataStore,
  handleToggleModalComment,
  handleToggleRatingModal,
  services,
  dataValue,
}: DataStoreProps) => {
  const { urlImg, logoColor, s3, phone, address, name, companyName, whatsapp, contacts } =
    dataStore;

  const defaultUser = !urlImg ? { backgroundColor: logoColor } : {};
  const logoBox = cx('br-100 overflow-hidden ba b--boulder', styles.logoStoreData);

  const renderLogo = () => {
    if (!urlImg) {
      return <NameInitials name={name} />;
    }

    const fullpath = `${s3}${urlImg}`;

    return <img src={fullpath} alt={name} title={name} className="h-100 w-100" />;
  };

  const businessHours = services ? services.businessHours : null;

  return (
    <div className="flex flex-column relative items-center">
      <div className={logoBox} style={defaultUser}>
        {renderLogo()}
      </div>
      <ShopTitle>{name}</ShopTitle>
      <section className="w-100 ph16 pb24">
        <ShopRatings
          rate={(services && services.note) || 0}
          total={(services && services.totalRating) || 0}
          ratings={[]}
          handleToggleModalComment={handleToggleModalComment}
          handleToggleRatingModal={handleToggleRatingModal}
        />
        <Divider className="mv24" />
        <ShopContact
          phone={phone}
          whatsapp={whatsapp}
          name={name}
          companyName={companyName}
          dataValue={dataValue}
          contacts={contacts}
        />
        {services?.description && (
          <>
            <Divider className="mv24" />
            <Description description={services?.description} />
          </>
        )}
        <Divider className="mv24" />
        <ShopAddressAndHourMobile
          address={address}
          dataValue={dataValue}
          businessHours={businessHours}
        />
      </section>
    </div>
  );
};
